import { blur } from 'redux-form'
import forEach from 'lodash/forEach'
import {
  defaulCrudConfigMaker,
  CRUDRouteMaker,
  CRUDlist,
} from '@infotech/crud'
import createFiltersConfig from '@infotech/filters'
import { URL, SERVICES_SCHEMA_NAME } from 'api/services'
import {
  getColumnsConf,
  getFormConfig,
  defaultFormList,
  getViewConfig,
  defaultViewList,
  defaultFormListEdit,
  defaultFilterList,
  getFilterConfig,
} from './fieldsConf'
import { CRUD_PATH } from './constants'

const filtersConfig = createFiltersConfig({
  entityName: SERVICES_SCHEMA_NAME,
})

export const defaultModuleConfig = {
  getGridConfig     : getColumnsConf,
  getFormConfig,
  getViewConfig,
  defaultFormList,
  defaultViewList,
  defaultFormListEdit,
  shouldRequestCount: false,
  routing           : {
    list: {
      title    : `Сервисы`,
      component: CRUDlist,
      filter   : {
        saveManagement: false,
        defaultFilterList,
        getFilterConfig,
        ...filtersConfig,
      },
    },
    create: {
      title            : `Создание сервиса`,
      submitButtonText : `Сохранить`,
      getSuccessMessage: () => `Сервис создан`,
    },
    edit: {
      title            : `Редактирование сервиса`,
      submitButtonText : `Сохранить`,
      getSuccessMessage: () => `Сервис отредактирован`,
    },
    read: {
      bottomWidgets: [],
    },
  },
}

export const moduleCrudConfig = (
  moduleConfig = defaultModuleConfig,
  crudPath = CRUD_PATH,
  apiUrl = URL
) => defaulCrudConfigMaker(moduleConfig, crudPath, apiUrl)

export const CRUDRoute = (
  config = moduleCrudConfig(),
  path = CRUD_PATH
) => CRUDRouteMaker(config, path)
